export default __webpack_public_path__ + "static/media/html.5f859328.svg";